import { createFileRoute } from "@tanstack/react-router"
import { uomLoader } from "shared/loaders"

import { TabletLayout } from "@/screens/Tablet/components"

export const Route = createFileRoute("/app/tablet")({
  component: TabletLayout,
  loader: uomLoader,
  staleTime: Infinity,
})
